import classNames from 'clsx';
import React from 'react';

import Loader from '@swf/components/StarsButton/components/Loader/Loader';

import styles from './LoadingIndicator.scss';
import PSLogo from './components/PSLogo';

interface Props {
  loading: boolean;
  className?: string;
  variant?: 'light' | 'dark' | 'poker';
}

const LoadingIndicator: React.FC<Props> = ({ loading, children, variant = 'dark', className }) => {
  if (!loading) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (variant === 'poker') {
    return <PSLogo />;
  }

  return (
    <div className={classNames(styles.centered, styles[variant], className)}>
      <Loader />
    </div>
  );
};

export default LoadingIndicator;
